import { r4Client, r4Error } from '../../services'
import useLogger from '@/composables/useLogger'
const logger = useLogger('EmailSenderStore')

const emailSenderParams = payload => {
  return payload
}

const EmailSenderStore = {
  namespaced: true,
  state: {
    emailSenders: [],
    emailSender: {}
  },
  mutations: {
    storeSenders: (state, payload) => (state.emailSenders = payload.data),
    storeSender: (state, payload) => {
      payload = payload || {}
      if (payload.data) {
        state.emailSender = payload.data
      } else {
        state.emailSender = payload
      }
    },
    setEmailSenderProp: (state, payload) => {
      state.emailSender[payload.field] = payload.value
    },
    resetSender: (state) => {
      state.emailSender = {}
    },
    resetSenders: (state) => {
      state.emailSenders = []
    }
  },
  actions: {
    fetchEmailSenders ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        r4Client()
          .get('/api/v1/email_senders', { params: payload })
          .then(response => {
            commit('storeSenders', response.data)
            resolve(state.emailSenders)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    createEmailSender ({ state, commit }, payload) {
      const emailSenderData = emailSenderParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .post('/api/v1/email_senders', emailSenderData)
          .then(response => {
            logger.trace('CreateEmailSender: Success')
            commit('storeSender', response.data)
            resolve(state.emailSender)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    updateEmailSender ({ state, commit }, payload) {
      const emailSenderData = emailSenderParams(payload)
      return new Promise((resolve, reject) => {
        r4Client()
          .put(`/api/v1/email_senders/${payload.id}`, emailSenderData)
          .then(response => {
            logger.trace('UpdateEmailSender: Success')
            commit('storeSender', response.data)
            resolve(state.emailSender)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    },
    // determines if create or update should be used
    saveEmailSender ({ dispatch }, payload) {
      return new Promise((resolve, reject) => {
        let actionPromise = null
        if (payload.id) {
          actionPromise = dispatch('updateEmailSender', payload)
        } else {
          actionPromise = dispatch('createEmailSender', payload)
        }
        actionPromise.then(response => {
          resolve(response)
        }).catch(error => {
          reject(r4Error(error))
        })
      })
    },
    getEmailSender ({ state, commit }, payload) {
      return new Promise((resolve, reject) => {
        return r4Client()
          .get(`/api/v1/dealers/${payload.dealer_id}/rooftops/${payload.dealer_rooftop_id}/email_senders/${payload.id}`)
          .then(response => {
            commit('storeSender', response.data)
            resolve(state.emailSender)
          })
          .catch(error => {
            reject(r4Error(error))
          })
      })
    }
  }
}

export default EmailSenderStore
